<template>
  <div>
    <el-dialog
      title = "上传数据"
      :visible.sync = "visible"
      :close-on-click-model="false"
      @close="dialogClose"
      append-to-body
      :width="`${900}px`"
    >
      <div class="search_group">
        <el-select @change="searchAct" v-model="formChild.dataType" size="small" clearable placeholder="请选择数据源">
          <el-option label="秒针IES" :value="1"></el-option>
          <el-option label="乐播云" :value="2"></el-option>
          <el-option label="客户数据-实结" :value="3"></el-option>
          <el-option label="客户数据-全结" :value="4"></el-option>
          <el-option label="历史结算导入" :value="5"></el-option>
        </el-select>
        <el-input style="width: 220px" size="small" v-model="formChild.search" placeholder="请输入项目名称" clearable></el-input>
        <el-button @click="onUploaded" icon="el-icon-search" size="small" type="primary">查询</el-button>
        <el-button @click="showUploadDialog = true" icon="el-icon-edit" size="small" type="warning">上传</el-button>
        <el-button icon="el-icon-search" size="small" type="danger" @click="deleteUploadData">删除</el-button>
      </div>
      <el-table :max-height="tableHeight"
        v-loading="listLoading" element-loading-text="加载中" border
        @selection-change="handleSelectionChange"
        :data="tableData">
        <el-table-column align="center" type="selection" width="55"></el-table-column>
        <el-table-column align="center" fixed prop="orderNo" label="项目编号" width="200"></el-table-column>
        <el-table-column align="left" prop="orderName" label="项目名称" width="100">
          <template slot-scope="scope">
          <span>{{ scope.row.parentId > 0 ? '【子项目】': ''}}{{scope.row.orderName}}</span>
        </template>
        </el-table-column>
        <el-table-column align="right" label="CPM数量" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showAreaDetail(scope.row)" >{{ scope.row.customerCurrCpm > -1 ?  scope.row.customerCurrCpm : ''  }}</el-button>
          </template>
        </el-table-column>
        <el-table-column align="left" label="原始文件">
          <template slot-scope="scope">
            <el-button type="text" @click="downloadOrgin(scope.row)" >{{ scope.row.thirdDataFileName }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_pagination">
        <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
        </el-pagination>
      </div>
      <uploadDialog :uploadDialogFlag.sync="showUploadDialog" :dataType="dataType" :editId="projectInfo.id" @uploaded="onUploaded"></uploadDialog>
      <area-detail-dialog :areaDetailDialogFlag.sync="showAreaDetailDialog" :fileName="dataFileName" :areaData="areaDeatailData"></area-detail-dialog>
    </el-dialog>
  </div>
</template>
<script>
import { settleDetailOrders, getSettleAreaDetail, deleteUploadData } from '@/api/projectSettlement/procedure'
import pagination from '@/util/mixins/pagination'
import uploadDialog from './uploadDialog.vue'
import areaDetailDialog from './areaDetailDialog.vue'
export default {
  mixins: [pagination],
  props: {
    updateDataDialogFlag: {
      type: Boolean,
      default: false
    },
    projectInfo: {
      type: Object,
      default: () => {}
    },
    editId: {
      type: String,
      default: ''
    },
    editType: {
      type: String,
      default: () => ''
    }
  },
  components: {
    uploadDialog,
    areaDetailDialog
  },
  data() {
    return {
      visible: false,
      dataType: 1, // 上传的数据类型
      showDetails: false, // 详情弹窗
      formChild: {
        search: '',
        dataType: ''
      },
      selectProject: [],
      // 地域详情数据
      areaDeatailData: [],
      dataFileName: '',
      // 上传的弹窗
      showUploadDialog: false,
      // 地域详情的弹窗
      showAreaDetailDialog: false
    }
  },
  mounted () {
  },
  methods: {
    dialogClose() {
      this.$emit('update:updateDataDialogFlag', false)
    },
    // 获取列表
    getList () {
      this.refreshing = false
      this.listLoading = true
      let postData = {
        search: this.formChild.search,
        dataType: this.formChild.dataType,
        settleId: this.projectInfo.id,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.data
          this.totalEl = res.data.data.totalCount
        } else {
          this.$message.error(res.data.msg)
        }
      }
      settleDetailOrders(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 上传完成刷新列表数据
    onUploaded() {
      this.pageNo = 1
      this.getList()
    },
    // 获取地域详情数据
    getCheckAreaDetailADatas(row) {
      let postData = {
        settleId: this.projectInfo.id,
        orderId: row.orderId
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.areaDeatailData = res.data.data
          this.dataFileName = row.orderName
        } else {
          this.$message.error(res.data.msg)
        }
      }
      getSettleAreaDetail(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 选择项目
    handleSelectionChange(val) {
      this.selectProject = val
    },
    // 删除上传的订单文件
    deleteUploadData() {
      if(this.selectProject.length > 0) {
        this.$confirm("确定将选择项的原始文件删除?","提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const ids = this.selectProject.map(item => item.id).join(',')
          const formData = new FormData();
          formData.append('ids', ids)
          deleteUploadData(formData).then(res => {
            if(res.data.code === 200 && res.data.success) {
              this.$message.success('删除原始文件成功')
              this.getList()
            }
          }).catch(err => {
            this.$message.error(err)
          })
        }).catch(() => {
          console.log('取消删除')
        })
      } else {
        this.$message.warning('请先选择项目')
      }
    },
    showUpload() {
      this.showUploadDialog = true
    },
    showAreaDetail(row) {
      this.showAreaDetailDialog = true
      this.getCheckAreaDetailADatas(row)
    },
    downloadOrgin(row) {
      window.open(row.thirdDataFileUrl)
    }
  },
  watch: {
    updateDataDialogFlag() {
      this.visible = this.updateDataDialogFlag
      if(this.visible) {
        this.onUploaded()
      }
    },
    showAreaDetailDialog(val) {
      if(!val) {
        this.dataFileName = ''
        this.areaDeatailData = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>